import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: calc(var(--spacing-3) / 2);
    width: 100%;

    @supports not (padding-inline: 0) {
        & > a:not(:nth-last-child(1)) {
            margin-bottom: calc(var(--spacing-3) / 2);
        }
    }
`;

export const SecondaryCtas = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: calc(var(--spacing-3) / 2);
    width: 100%;
    margin-top: var(--spacing-2);
`;

export const VehicleAggregation = styled.div`
    display: flex;
    align-items: center;
    align-self: stretch;
    justify-content: center;
    gap: var(--spacing-1);
    padding-block: var(--spacing-1);
    padding-inline: var(--spacing-3);
    color: var(--color-midnight);
`;

export const VehicleAggregationText = styled.div`
    display: flex;
    align-items: center;
    gap: calc(var(--spacing-1) / 2);
    font-family: var(--font-regular);
    font-size: 1.3rem;
    line-height: 2rem;

    span {
        font-family: var(--font-bold);
    }
`;
